module.exports = __webpack_public_path__ + "img/cream.6bbaae34.svg";